import Delete from "@mui/icons-material/Delete";
import { IconButton, Stack } from "@mui/material";
import Spin from "components/Spin";
import PinButton from "components/UI/atoms/PinButton";
import useRedirect from "helpers/hooks/useRedirect";
import { isTrue } from "helpers/utils/validators";
import moment from "moment";

export const getJobAndSkillJSXCols = (
  onClickPin,
  handleDeleteItem,
  deletingItemId,
  navigateToDetail,
  t = (d) => d
) => {
  return [
    {
      title: t("Title"),
      render: (rowData) => {
        return (
          <p
            className="w-150 text-truncate fs-14 fw-500 tracking-tight link"
            onClick={() => navigateToDetail(rowData?.id)}
          >
            {" "}
            {rowData?.title}
          </p>
        );
      },
    },
    {
      title: t("Skills"),
      render: (rowData) => {
        const skillsToShow = rowData?.related_skills || rowData?.skills;
        return (
          <p className="w-220 maxw-220 text-truncate-2 text-wrap tracking-tight c-gray">
            {skillsToShow?.length > 0
              ? skillsToShow?.map((skill) => skill?.title || skill).join(", ")
              : "-"}
          </p>
        );
      },
    },
    {
      title: t("Challenges"),
      render: (rowData) => {
        return <p>{rowData?.related_challenges_count || "0"}</p>;
      },
    },
    {
      title: t("Labs"),
      render: (rowData) => {
        return <p className="w-30">{rowData?.related_labs_count || "0"}</p>;
      },
    },
    {
      title: t("Resources"),
      render: (rowData) => {
        return <p>{rowData?.related_resources_count || "0"}</p>;
      },
    },
    {
      title: t("Saved on"),
      render: (rowData) => (
        <p className="tracking-tight">
          {rowData?.saved_on
            ? moment(new Date(rowData?.saved_on)).format("MMMM DD, YYYY")
            : "-"}
        </p>
      ),
    },
    {
      render: (rowData) => {
        return (
          <Stack direction="row" alignItems="center">
            <PinButton
              isPinned={isTrue(rowData?.pinned)}
              onClick={() => onClickPin(rowData?.id, rowData?.pinned)}
            />
            {deletingItemId === rowData.id ? (
              <Spin blue />
            ) : (
              <IconButton
                className="h-30 w-30"
                onClick={() => handleDeleteItem(rowData?.id)}
              >
                <Delete color="error" fontSize="small" />
              </IconButton>
            )}
          </Stack>
        );
      },
    },
  ];
};

export const useBrowseNavigate = (isSkills) => {
  const { navigateCareerExplore, navigateSavedCareers, navigateSavedSkills } =
    useRedirect();

  const handleBrowseNavigate = (value) => {
    switch (value) {
      case 0:
        navigateCareerExplore();
        return;
      case 1:
        navigateSavedCareers();
        return;
      case 2:
        if (!isSkills) navigateSavedSkills();
        return;
    }
  };
  return handleBrowseNavigate;
};

export const groupSkillsIntoSlides = (skills) => {
  const groupedSkills = [];
  for (let i = 0; i < skills.length; i += 9) {
    groupedSkills.push(skills.slice(i, i + 9));
  }
  return groupedSkills;
};
